import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromParcel from '../_reducers/parcel';

export const selectParcelState = createFeatureSelector<fromParcel.ParcelState>('parcels');

export const selectAllParcels = createSelector(selectParcelState, fromParcel.selectAll);

export const selectParcelEntities = createSelector(selectParcelState, fromParcel.selectEntities);

export const selectParcelById = (id: number) =>
  createSelector(selectParcelEntities, (entities) => entities[id]);

export const selectParcelTotal = createSelector(selectParcelState, fromParcel.selectTotal);

export const selectParcelWithStatus = createSelector(
  selectParcelState,
  selectAllParcels,
  (state, parcels) => ({
    parcels,
    loading: state.loading,
    loaded: state.loaded,
    error: state.error,
  })
);
